import React from 'react';
import styles from './SideImageWithInfoCards.module.scss';
import Img from '@/components/Img';
import { mediaPath } from '@/mediaPath';
import Text from '@/components/Text/Text';

interface Image {
  height: number,
  width: number,
  url: string
}

export interface InfoCard {
  id: number;
  title: string;
  description: string;
  icon: Image;
}

export interface IngredientSideImageWithInfoCards {
  __component: 'ingredient.side-image-with-info-cards';
  id: number;
  title: string;
  description: string;
  imageAlignment: 'left' | 'right';
  cardsTitle: string;
  image: Image;
  infoCards: InfoCard[];
}

const SideImageWithInfoCards = ({ data }: { data: IngredientSideImageWithInfoCards }) => {
  const divStyle = {
    backgroundColor: 'lightgray',
    backgroundImage: `
    url(${mediaPath(data.image.url)})
  `,
    backgroundPosition: 'center, -35.432px 0',
    backgroundSize: 'cover, 203.579% 100%',
    backgroundRepeat: 'no-repeat, no-repeat',
    borderRadius: '8px',
    // width: '300px',
    height: '100%',
  };
  return (
    <section className={styles.imageWithIconText}>
      <div style={divStyle} />
      <div className={styles.content2}>
        <Text
          tag='h2'
        >
          {data.cardsTitle}
        </Text>
        <div className={styles.infoContent}>
          {data.infoCards.map((card) => (
            <div key={card.id}>
              <Img
                src={card.icon.url}
                height={48}
                width={48}
              />
              <h6>{card.title}</h6>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SideImageWithInfoCards;
